import { Grid2 } from "@mui/material";
import { useEffect, useState } from "react";

import { CatalogDelayCodePage } from "./CatalogDelayCodePage";
import { ConfigurationDelayCodeProvider } from "./context/ConfigurationDelayCodeContext";
import { DelayAreaSelector } from "@/shared/selectors/DelayAreaSelector";
import { useUserContext } from "@dexteel/mesf-core";

const ASSET_NAMES: Record<number, string> = {
	11: "Mill #1",
	12: "Mill #2",
};

const CatalogDelayCodes = () => {
	const {
		state: { defaultAreaId },
	} = useUserContext();

	const [assetId, setAssetId] = useState(Number(defaultAreaId) || 12);
	const assetName = ASSET_NAMES[assetId];

	useEffect(() => {
		setAssetId(Number(defaultAreaId) || 12);
	}, [defaultAreaId]);

	return (
		<ConfigurationDelayCodeProvider>
			<Grid2 container spacing={1} p={1}>
				<Grid2 size={{ md: 3 }}>
					<DelayAreaSelector
						value={assetId}
						onChange={setAssetId}
						label="Delay Area"
					/>
				</Grid2>
			</Grid2>
			<CatalogDelayCodePage
				delayAreaAssetId={assetId}
				delayAreaAssetName={assetName}
			/>
		</ConfigurationDelayCodeProvider>
	);
};

export default CatalogDelayCodes;
